var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class FakeApiItemsGateway {
    static create({ factory, itemsToGenerate, }) {
        const items = factory.generate(itemsToGenerate);
        return new FakeApiItemsGateway(items);
    }
    constructor(_items, _delay = 200) {
        this._items = _items;
        this._delay = _delay;
    }
    get items() {
        return this._items;
    }
    set delay(ms) {
        if (!Number.isSafeInteger(ms) && ms < 0) {
            throw new Error("Delay parameter should be a positive integer in milliseconds ");
        }
        this._delay = Math.round(ms);
    }
    retrieveItems({ offset, size } = {
        offset: 1,
        size: this._items.length,
    }) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                if (!Number.isSafeInteger(offset) || !Number.isSafeInteger(size)) {
                    reject(new Error("Please provide valid offset and size numbers"));
                }
                setTimeout(() => {
                    const safeSize = Math.round(size !== null && size !== void 0 ? size : this._items.length);
                    const safeOffset = Math.round(offset);
                    const start = safeOffset - 1;
                    if (safeOffset >= this._items.length ||
                        safeSize <= 0 ||
                        start < 0 ||
                        start >= this._items.length) {
                        resolve([]);
                        return;
                    }
                    const end = start + safeSize;
                    resolve(this._items.slice(start, end));
                }, this._delay);
            });
        });
    }
}
//# sourceMappingURL=fakeApiItemsGateway.js.map